export default "__VITE_ASSET__DI1swv4a__"